import dateRange from "../../components/utils/DateRange";
export default (context) => {
  return {
    config: {
      hiddenTitle: true,
      pageSize: 40,
      list: false
    },
  
    actions: {
      search: true,
      edit: true,
      print: true,
      export: true
    },

    filter: {
      fields: [
        ...dateRange()
      ],
      buttons: [
        {
          label: 'main.applyFilter',
          renderIf: (ctx) => { return ctx.state.range || ctx.state.from || ctx.state.to },
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      fields: [
        {
          col: 6,
          name: "userName",
          value: null,
          type: "text",
          label: "main.user",
          opts: {
            style: 'float-label'
          },
          disabled: true
        },
        {
          col: 6,
          name: "moduleId",
          value: null,
          type: "text",
          label: "main.module",
          opts: {
            style: 'float-label'
          },
          disabled: true
        },
        {
          col: 6,
          name: "date",
          value: null,
          type: "text",
          label: "main.date",
          opts: {
            style: 'float-label'
          },
          disabled: true
        },
        {
          col: 6,
          name: "action",
          value: null,
          type: "text",
          label: "main.action",
          opts: {
            style: 'float-label'
          },
          disabled: true
        },
        {
          col: 6,
          name: "IP",
          value: null,
          type: "text",
          label: "main.IPadress",
          opts: {
            style: 'float-label'
          },
          disabled: true
        },
        {
          col: 6,
          name: "lat",
          value: null,
          type: "text",
          label: "main.location",
          opts: {
            style: 'float-label'
          },
          disabled: true
        }
      ]
    },

    columns: [
      { Header: "main.event", accessor: "ID" },
      { Header: "main.user", accessor: "name" },
      { Header: "main.date", accessor: "date" },
      { Header: "main.module", accessor: "module" },
      { Header: "main.action", accessor: "action" }
    ]
  }
}